import { FC, useState } from 'react'

import { useTranslation } from 'react-i18next'

import clsx from 'clsx'

import { InfoTicketMyTicket } from 'entities/ticket/ui/info-ticket/info-ticket'

import { MyTicketItem } from 'shared/api/MyTicketsModel'
import { AppIcon } from 'shared/ui/app-icon'
import { AllIcons } from 'shared/ui/app-icon/types'
import { Paper } from 'shared/ui/paper'

import s from './styles.module.scss'

interface Props {
  ticket: MyTicketItem
  isBookedTicket?: boolean
}

export const FlightDetailInfo: FC<Props> = ({ ticket }) => {
  const { t } = useTranslation()
  const [isOpen, setIsOpen] = useState(false)

  return (
    <div
      className={s.container}
      onClick={() => setIsOpen(!isOpen)}
    >
      <Paper
        padding={[16]}
        radius={16}
      >
        <div className={s.paperContainer}>
          <div className={s.wrapper}>
            <p className={clsx('semi-bold-17')}>{t('tariff')}</p>

            <div className={s.content}>
              {!isOpen && (
                <p className={clsx('regular-15', s.tariff)}>
                  {ticket?.fare?.fare_family_type || ''}
                </p>
              )}

              <AppIcon
                id={AllIcons.ARROW_RIGHT_TARIFF}
                width={20}
                height={20}
                className={clsx(s.icon, isOpen && s.icon_open)}
              />
            </div>
          </div>

          {isOpen && <InfoTicketMyTicket ticket={ticket} />}
        </div>
      </Paper>
    </div>
  )
}
